import { usePreloadedItems } from '@fukku/slideshow/hooks/usePreloadedItems/usePreloadedItems'
import { useSlideshowBullets } from '@fukku/slideshow/hooks/useSlideshowBullets/useSlideshowBullets'
import styles from '@fukku/slideshow/Slideshow.module.scss'
import { useEffect } from 'react'

export const SlideshowPreloadedItems = () => {
	const { bulletIndex } = useSlideshowBullets()
	const { preloadedItems, preloadNeighborItems } = usePreloadedItems()

	useEffect(() => {
		if (bulletIndex !== 0) {
			preloadNeighborItems(bulletIndex)
		}
	}, [bulletIndex, preloadNeighborItems])

	return (
		<>
			{preloadedItems?.map((preloadItem) => (
				<span
					className={styles.preloadedItem}
					aria-hidden
					key={preloadItem.key}
				>
					{preloadItem}
				</span>
			))}
		</>
	)
}
